<template>
  <el-form-item :label="i18nt('designer.setting.defaultValue')">
    <el-date-picker :type="datePickerType" v-model="optionModel.defaultValue" @change="emitDefaultValueChange" :value-format="optionModel.format" style="width: 100%"> </el-date-picker>
  </el-form-item>
</template>

<script>
import { toRefs, computed } from 'vue';

import { useI18n } from '@/utils/i18n';
import { useProperty } from '@/components/form-designer/setting-panel/property-editor/propertyMixin';
import { useDateDefaultValue } from '../field-date/date-defaultValue';

export default {
  name: 'm-date-range-defaultValue-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const properyMixins = useProperty();

    return {
      i18nt,
      ...toRefs(props),
      ...properyMixins,
      ...useDateDefaultValue(),
    };
  },
};
</script>

<style scoped></style>
